import * as React from 'react';
import Lottie from 'react-lottie';

interface Props {
  anim: object;
  loop: boolean;
  width: number | string;
  height: number | string;
}

const LottieWrapper: React.FC<Props> = ({ loop, anim, width, height }) => {
  const options = {
    loop,
    autoplay: true,
    animationData: anim,
    rendererSettings: {
      preserveAspectRatio: true,
    },
  };
  return <Lottie options={options} height={height} width={width} />;
};

export default LottieWrapper;



// WEBPACK FOOTER //
// ./src/components/animated/LottieWrapper.tsx